import {
  prefectureOptions
} from '../../../const';
export type InputData = {
  [key: string]: string,
}
export const initialInputData: InputData = {
  userCode: "",
  firstName: "",
  lastName: "",
  firstNameKana: "",
  lastNameKana: "",
  tel: "",
  email: "",
}
export type InputDataConfig = {
  [key: string]: {
    name: string,
    type: string,
    options?: {value: string, label: string}[],
    placeholder?: string,
    required?: boolean,
    caution?: string,
    pattern?: RegExp,
  }
}

export const inputDataConfig: InputDataConfig = {
  userCode: {
    name: "お客様コード",
    type: "text",
    placeholder: "例) 00100000",
    required: true,
  },
  lastName: {
    name: "お名前 [姓　※法人の場合は商号]",
    type: "text",
    placeholder: "例) 山田",
    required: true,
  },
  firstName: {
    name: "お名前 [名　※法人の場合は担当者名]",
    type: "text",
    placeholder: "例) 太郎",
    required: true,
  },
  lastNameKana: {
    name: "お名前(かな) [姓　※法人の場合は商号]",
    type: "text",
    placeholder: "例) やまだ",
    required: true,
  },
  firstNameKana: {
    name: "お名前(かな) [名　※法人の場合は担当者名]",
    type: "text",
    placeholder: "例) たろう",
    required: true,
  },
  tel: {
    name: "電話番号(ハイフン抜き)",
    type: "text",
    placeholder: "例) 0000000000",
    required: true,
    pattern: /^\d{10}\d?$/,
  },
  email: {
    name: "メールアドレス",
    type: "text",
    placeholder: "例) sample@example.com",
    required: true,
    pattern: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
  },
}
